import * as React from "react";

import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { parse_text_with_link } from "./details-utils"

export const DescMech = (props: any) => {

    const { t, i18n } = useTranslation();

    return (
        <>
            {/* Disclaimer for RoboDK objects */}
            {
                props.data.hasOwnProperty("B") && props.data["B"] == "RoboDK" && (
                    <p>
                        {
                            (t('details-desc.robodk'))
                                .replace(/\{name\}/g, props.data["N"])
                        }
                    </p>
                )
            }

            <p>
                {/* Description */}
                {
                    props.data.hasOwnProperty("N") && props.data.hasOwnProperty("A") && props.data["A"] > 0 && props.data.hasOwnProperty("T") && (
                        (t('details-desc.mechanism.name'))
                            .replace(/\{name\}/g, props.data["N"])
                            .replace(/\{axes\}/g, props.data["A"])
                            .replace(/\{type\}/g, t('details-desc.item-types-desc.' + props.data["T"]))  // props.data["T"]
                    )
                }
                {
                    props.data.hasOwnProperty("P") && (
                        " " +
                        (t('details-desc.mechanism.payload'))
                            .replace(/\{payload\}/g, props.data["P"])
                    )
                }
                {
                    props.data.hasOwnProperty("R") && (
                        " " +
                        (t('details-desc.mechanism.reach'))
                            .replace(/\{reach\}/g, props.data["R"])
                    )
                }
                {
                    props.data.hasOwnProperty("E") && (
                        " " +
                        (t('details-desc.mechanism.repeatability'))
                            .replace(/\{name\}/g, props.data["N"])
                            .replace(/\{repeatability\}/g, props.data["E"])
                    )
                }
                {
                    props.data.hasOwnProperty("W") && (
                        " " +
                        (t('details-desc.mechanism.weight'))
                            .replace(/\{weight\}/g, props.data["W"])
                    )
                }
            </p>

            {/* Applications */}
            {
                <p>
                    {
                        props.data.hasOwnProperty("N") && props.data.hasOwnProperty("AP") && (
                            (t('details-desc.apps'))
                                .replace(/\{name\}/g, props.data["N"])
                                .replace(/\{applications\}/g, t('application.' + props.data["AP"]))
                        )
                    }
                </p>
            }

            {/* Brand */}
            {
                props.data.hasOwnProperty("N") && props.data.hasOwnProperty("B") && (
                    <p>
                        {
                            (t('details-desc.brand'))
                                .replace(/\{name\}/g, props.data["N"])
                                .replace(/\[\{brand\}\]\(\{link\}\)/g, props.data["B"])
                        }
                    </p>
                )
            }

            {/* Browse the library */}
            {
                parse_text_with_link(
                    (t('details-desc.browse'))
                        .replace(/\{link\}/g, (window.Settings.LOCAL_BUILD)
                            ? "http://localhost:3001?Lang=" + window.Languages.language + "&n=" + props.data["F"].split(".", 1)[0]
                            : "/" + (window.Languages.language == "en" ? "" : (window.Languages.language + "/")) + (props.data["T"] == "Ext. axis" ? "axes" : "objects") + "?n=" + props.data["F"].split(".", 1)[0])
                )
            }
        </>
    )
};
